import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';

/**
 * PATCH /api/eraf/users/{id}/lock — 사용자 잠금
 * 성공 시 상세/목록 쿼리 무효화
 */
export function useLockUser(id: number) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (reason?: string) => userApi.lock(id, reason),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'detail', id] });
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
    },
  });
}
